




















































































import Vue from "vue";
import { onMounted } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import { TimeAxisType } from "@/gql/types";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import SharedByEmployeesCard from "./card-items/SharedByEmployeesCard.vue";
import SharedByEmployeesTopCard from "./card-items/SharedByEmployeesTopCard.vue";
import InformationInvolvedCard from "./card-items/InformationInvolvedCard.vue";
import RiskBySeverityCard from "./card-items/RiskBySeverityCard.vue";
import SensitivityMatrixCard from "./card-items/SensitivityMatrixCard.vue";
import {
  DropDownItem,
  UseDropdownItems,
} from "@/common/composition/dropdown-items";
import { SIZE, TYPE, UNIT, useGenAiPalette } from "./data/design";
import { state } from "./data/state";

export default Vue.extend({
  components: {
    DropDownSimple,
    SharedByEmployeesCard,
    SharedByEmployeesTopCard,
    InformationInvolvedCard,
    RiskBySeverityCard,
    SensitivityMatrixCard,
  },
  setup() {
    /**
     * The app's standard time-frame list (Current week, Last week, then the
     * months), the same source the other overview pages feed their "From"
     * dropdown from.
     *
     * The selection drives the shared time frame, which is what the gql layer
     * reads as `frame`. It used to be display-only — harmless while the cards
     * came from a constant that ignored time, and wrong the moment they came
     * from the API.
     */
    const [
      time_frames,
      selected_time_frame,
      set_selected_time_frame,
      init_time_frames,
    ] = UseDropdownItems<DropDownItem>([]);

    onMounted(() => {
      const options = SharedState.timeFrameOptions.value;
      if (!options.length) {
        return;
      }
      init_time_frames(
        options.map((t) => ({ id: t.displayName, name: t.displayName }))
      );
      // Show the frame the queries actually use. After login the app selects
      // the latest month the org has data for, which is not always the
      // current one — defaulting the label to the first month let it read
      // "September" over August's numbers.
      const shared = SharedState.selectedTimeFrameDisplayName.value;
      const current_month = options.find(
        (t) => t.type === TimeAxisType.Month
      );
      set_selected_time_frame(
        options.some((t) => t.displayName === shared)
          ? shared
          : (current_month || options[0]).displayName
      );
    });

    /**
     * Push the choice into shared state and refetch. The dropdown carries
     * display names, so the option is resolved back by name before selecting.
     */
    const on_time_frame_change = (picked: string | { id: string }) => {
      set_selected_time_frame(picked);

      // DropDownSimple emits the item object; the setter above accepts either
      // form, but the lookup below needs the bare id (which is the display name).
      const display_name = typeof picked === "string" ? picked : picked.id;
      const option = SharedState.timeFrameOptions.value.find(
        (t) => t.displayName === display_name
      );
      if (!option) {
        console.warn("[gen-ai] no time frame option for", display_name);
        return;
      }

      // `changeTimeFrame` is the app's own action for this; calling the
      // mutation directly would bypass the store.
      SharedState.changeTimeFrame(option);
      state.init();
    };

    return {
      time_frames,
      selected_time_frame,
      set_selected_time_frame,
      on_time_frame_change,
      T: useGenAiPalette(),
      TY: TYPE,
      S: { ...SIZE, unit: UNIT },
    };
  },
});
